import { makeActionCreator } from '_core/utils/actions'
import { createSelector } from 'reselect'
// === Action types ===

const BENZOBOT_RESET = 'BENZOBOT_RESET'
const BENZOBOT_CHANGE = 'BENZOBOT_CHANGE'
const BENZOBOT_UPDATE = 'BENZOBOT_UPDATE'
const BENZOBOT_DETAILS_UPDATE = 'BENZOBOT_DETAILS_UPDATE'
const BENZOBOT_SELECTED_UPDATE = 'BENZOBOT_SELECTED_UPDATE'

// === Default state ===

const defaultState = {
  stations: null,
  details: {},
  selected: {},
}

// === Selectors ===
const getBenzobot = store => {
  return store.benzobot
}

const getBenzobotStations = createSelector(getBenzobot, benzobot => {
  return benzobot.stations
})

const getBenzobotFuelTypes = createSelector(getBenzobot, benzobot => {
  return benzobot.fuelTypes
})

const getBenzobotDetails = createSelector(getBenzobot, benzobot => {
  return benzobot.details
})

const getBenzobotSelected = createSelector(getBenzobot, benzobot => {
  return benzobot.selected
})

// === Actions ===

const changeBenzobot = makeActionCreator(BENZOBOT_CHANGE, 'id')

const updateBenzobot = makeActionCreator(BENZOBOT_UPDATE, 'data')

const resetBenzobot = makeActionCreator(BENZOBOT_RESET)

const updateBenzobotDetails = makeActionCreator(BENZOBOT_DETAILS_UPDATE, 'data')

const updateSelectedBenzobot = makeActionCreator(
  BENZOBOT_SELECTED_UPDATE,
  'data'
)

// === Exports ===

export const benzobotDefaultState = defaultState

export const benzobotActionTypes = {
  BENZOBOT_RESET,
  BENZOBOT_CHANGE,
  BENZOBOT_UPDATE,
  BENZOBOT_DETAILS_UPDATE,
  BENZOBOT_SELECTED_UPDATE,
}

export const benzobotSelectors = {
  getBenzobot,
  getBenzobotStations,
  getBenzobotFuelTypes,
  getBenzobotDetails,
  getBenzobotSelected,
}

export const benzobotActions = {
  changeBenzobot,
  updateBenzobot,
  resetBenzobot,
  updateBenzobotDetails,
  updateSelectedBenzobot,
}
